module.exports = __webpack_public_path__ + "static/media/Hero_Image_Mobile_3.74cb4990.jpg";